module.exports = __webpack_public_path__ + "img/img.d4e52013.png";